import AdSlot from "@/components/AdSlot";
import { useAdSetting } from "@/lib/adSettings";

// Placement 1: a single banner ad that matches the list width, shown at the end
// of the top (first) list on a page. Max one per page (caller enforces this).
export default function InListAd() {
    const on = useAdSetting("in_list");
    const slot = process.env.REACT_APP_ADSENSE_IN_FEED_SLOT;
    if (!on) return null;
    return (
        <div className="mt-4" data-testid="ad-in-list">
            <AdSlot slot={slot} format="horizontal" minHeight={110} refreshKey="in-list" placement="in_list" />
        </div>
    );
}
